import jQuery from "jquery";

jQuery(document).ready(function($){

   let setEvents = function() {
     
   }

   let copySubMenu = function() {
      let isDeph4 = $('.current-menu-ancestor > .sub-menu > li.current-page-parent').length > 0;
      let _html = '';
      let $output = $('.ex-submenu-container');

      if (isDeph4) {
         _html = $('.current-menu-ancestor > .sub-menu > li.current-page-parent > .sub-menu').first().clone();
      } else {
         _html = $('.current-menu-ancestor > .sub-menu li.current-menu-item > .sub-menu').first().clone();
      }

      if ($output.length > 0) {
         if (_html == '') {
            $output.remove()
         } else {
            $output.append(_html)
            $output.addClass('active')
         }
      }
   }

   let init = function() {
      setEvents()
      copySubMenu()
      
   }

   // $topMenuMainContainer.append('<div class="ex-top-menu-submenu"></div>');

   init()
 });